/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIRichContact
 */
export interface APIRichContact {
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    readonly self: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRichContact
     */
    addresses?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIRichContact
     */
    readonly suppliers: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIRichContact
     */
    readonly customers: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof APIRichContact
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIRichContact
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRichContact
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIRichContact
     */
    preferredContactMethod?: APIPlanningEnum | null;
}



/**
 * Check if a given object implements the APIRichContact interface.
 */
export function instanceOfAPIRichContact(value: object): value is APIRichContact {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('suppliers' in value) || value['suppliers'] === undefined) return false;
    if (!('customers' in value) || value['customers'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIRichContactFromJSON(json: any): APIRichContact {
    return APIRichContactFromJSONTyped(json, false);
}

export function APIRichContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRichContact {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'addresses': json['addresses'] == null ? undefined : json['addresses'],
        'suppliers': json['suppliers'],
        'customers': json['customers'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'language': json['language'] == null ? undefined : json['language'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferredContactMethod': json['preferred_contact_method'] == null ? undefined : APIPlanningEnumFromJSON(json['preferred_contact_method']),
    };
}

export function APIRichContactToJSON(value?: Omit<APIRichContact, 'self'|'suppliers'|'customers'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'addresses': value['addresses'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'language': value['language'],
        'comment': value['comment'],
        'preferred_contact_method': APIPlanningEnumToJSON(value['preferredContactMethod']),
    };
}

